/**
 * CHG-053 REQ-V53-013/014: 이슈 이동 API 서비스
 */
import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface MovePreviewResult {
  canMove: boolean;
  sourceProject: { id: string; name: string; projectKey: string };
  targetProject: { id: string; name: string; projectKey: string };
  issue: { issueId: string; title: string };
  typeMapping: {
    sourceType: { issueTypeId: string; name: string; icon: string; color: string };
    autoMappedType: { issueTypeId: string; name: string } | null;
    requiresManualMapping: boolean;
    availableTypes: { issueTypeId: string; name: string; icon: string; color: string }[];
  };
  statusMapping: {
    autoMappedStatus: { statusId: string; name: string } | null;
    availableStatuses: { statusId: string; name: string; category: string }[];
  };
  fieldCompatibility: {
    compatible: string[];
    willBeLost: string[];
    totalCustomFields: number;
  };
  hierarchyWarnings: string[];
}

export async function movePreview(issueId: string, targetProjectId: string): Promise<MovePreviewResult> {
  const res = await api.post<ApiResponse<MovePreviewResult>>(`/issues/${issueId}/move/preview`, { targetProjectId });
  return res.data.data!;
}

export async function moveIssue(issueId: string, data: {
  targetProjectId: string;
  targetIssueTypeId: string;
  targetStatusId: string;
  keepCustomFields?: boolean;
}) {
  const res = await api.post<ApiResponse<any>>(`/issues/${issueId}/move`, data);
  return res.data.data!;
}

export interface HierarchyOverrideData {
  effectiveRules: {
    parentType: { issueTypeId: string; name: string; icon: string } | null;
    childType: { issueTypeId: string; name: string; icon: string };
    source: 'scheme' | 'override';
  }[];
  overrides: {
    id: string;
    parentType: { issueTypeId: string; name: string; icon: string } | null;
    childType: { issueTypeId: string; name: string; icon: string };
    action: 'ADD' | 'REMOVE';
  }[];
  hierarchyTree: unknown[];
}

export async function fetchHierarchyOverrides(projectId: string): Promise<HierarchyOverrideData> {
  const res = await api.get<ApiResponse<HierarchyOverrideData>>(`/projects/${projectId}/issue-type-config/hierarchy`);
  return res.data.data!;
}

export async function addHierarchyOverride(projectId: string, data: { parentTypeId: string | null; childTypeId: string; action: 'ADD' | 'REMOVE' }): Promise<HierarchyOverrideData> {
  const res = await api.post<ApiResponse<HierarchyOverrideData>>(`/projects/${projectId}/issue-type-config/hierarchy-overrides`, data);
  return res.data.data!;
}

export async function removeHierarchyOverride(projectId: string, overrideId: string): Promise<HierarchyOverrideData> {
  const res = await api.delete<ApiResponse<HierarchyOverrideData>>(`/projects/${projectId}/issue-type-config/hierarchy-overrides/${overrideId}`);
  return res.data.data!;
}
